import { render, staticRenderFns } from "./laborDetail.vue?vue&type=template&id=49c2da1e&scoped=true"
import script from "./laborDetail.vue?vue&type=script&lang=js"
export * from "./laborDetail.vue?vue&type=script&lang=js"
import style0 from "./laborDetail.vue?vue&type=style&index=0&id=49c2da1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c2da1e",
  null
  
)

export default component.exports